import React from 'react'

export const DialogsContext = React.createContext()

import { sendToAnalytics } from './Analytics'

import { UserContext } from './UserContext'

export const DialogsProvider = ({ children }) => {
    const { username } = React.useContext(UserContext)
    // State for tracking which import dialog is open
    const [activeImportDialog, setActiveImportDialog] = React.useState(false) // possible values: 'import', 'news', false

    const [backLinkDialog, setBackLinkDialog] = React.useState('backLink')

    const [presetSearchString, setPresetSearchString] = React.useState('')

    const [presetContext, setPresetContext] = React.useState('')

    const [presetFiles, setPresetFiles] = React.useState([])

    // Which import dialog the first-entry (empty graph) flow auto-opened,
    // if any. Read by FirstEntryController (to render the "reopen import"
    // empty-state overlay after the user closes the dialog) and by
    // LazyGraph (to suppress its own GraphEmptyState so the two centered
    // messages don't stack).
    const [firstEntryDialog, setFirstEntryDialog] = React.useState(false)

    // The dialog shown immediately before the current one, so a dialog can
    // adapt to where the user came from (e.g. the generic shortTextImport
    // picker opening on the 'ai' chip when reached from an AI panel). Updated
    // by the effect below AFTER each commit, so a freshly-mounted dialog reads
    // the prior value during its first render.
    const previousImportDialog = React.useRef(false)

    // Common methods to open/close dialogs
    const openImportDialog = dialogType => setActiveImportDialog(dialogType)
    const closeImportDialog = () => setActiveImportDialog(false)

    // // State for another example dialog
    // const [isGraphDialogOpen, setGraphDialogOpen] = React.useState(false)
    // const openGraphDialog = () => setGraphDialogOpen(true)
    // const closeGraphDialog = () => setGraphDialogOpen(false)

    React.useEffect(() => {
        if (activeImportDialog)
            sendToAnalytics({
                userId: username,
                event: 'choose_import_app',
                data: { app: activeImportDialog },
            })
        previousImportDialog.current = activeImportDialog
    }, [activeImportDialog])

    return (
        <DialogsContext.Provider
            value={{
                activeImportDialog,
                setActiveImportDialog,
                previousImportDialog,
                openImportDialog,
                closeImportDialog,
                backLinkDialog,
                setBackLinkDialog,
                presetSearchString,
                setPresetSearchString,
                presetContext,
                setPresetContext,
                presetFiles,
                setPresetFiles,
                firstEntryDialog,
                setFirstEntryDialog,
                // isGraphDialogOpen,
                // openGraphDialog,
                // closeGraphDialog,
            }}
        >
            {children}
        </DialogsContext.Provider>
    )
}
